const APP_ASSET_PATTERN = /^app\.[^/]+\.js$/i;

export function appAssetName(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '';
  }
  try {
    const pathname = new URL(raw, 'https://app-version.invalid/').pathname;
    const name = pathname.split('/').filter(Boolean).pop() || '';
    return APP_ASSET_PATTERN.test(name) ? name : '';
  } catch {
    return '';
  }
}

export function appAssetNameFromHtml(html) {
  const source = String(html || '');
  const scripts = source.matchAll(/<script\b[^>]*\bsrc\s*=\s*(["'])(.*?)\1/gi);
  for (const match of scripts) {
    const name = appAssetName(match[2]);
    if (name) {
      return name;
    }
  }
  return '';
}

export function hasNewAppVersion(currentAssetUrl, deployedHtml) {
  const current = appAssetName(currentAssetUrl);
  const deployed = appAssetNameFromHtml(deployedHtml);
  return Boolean(current && deployed && current !== deployed);
}
